import { Notifications } from '../locales/types';
import { AuthCodeErrorCode } from '../types/enums/auth-code-error-code.enum';
import { ErrorResponse } from '../types/interfaces/error-response.interface';

export const getAuthCodeNotificationKey =  (error: ErrorResponse): keyof Notifications => {
  switch (error.details as AuthCodeErrorCode) {
    case AuthCodeErrorCode.EXPIRED: return 'linkExpired';
    case AuthCodeErrorCode.USED: return 'linkUsed';
    case AuthCodeErrorCode.REVOKED: return 'linkExpired';
    case AuthCodeErrorCode.NOT_FOUND: return 'linkInvalid';
  }
};
